import { useParams } from "@tanstack/react-router";
import { AnalyticsCatalogContext, catalogSeoQualityTier } from "@/components/analytics-catalog-context";
import { ReleaseContent } from "./$id/release-content";
type ReleaseSearch = {
  playing?: string;
};
interface ReleaseBreadcrumbInput {
  title: string;
  workId: string | null;
  workTitle: string | null;
  primaryIndex: {
    label: string;
    path: string;
  } | null;
  artists: Array<{
    id: string;
    name: string;
  }>;
}
import { Route } from "/app/apps/web/src/routes/_app/release/$id.tsx";
function ReleaseRoute() {
  const {
    id
  } = useParams({
    from: "/_app/release/$id"
  });
  const loaderData = Route.useLoaderData();
  return <>
      <AnalyticsCatalogContext entityType="release" qualityTier={catalogSeoQualityTier(loaderData.release)} />
      <ReleaseContent id={id} />
    </>;
}
export { ReleaseRoute as component };